'use strict';

(function () {
  angular
    .module('flightWatch')
    .component('slotMessageSearchComponent', {
      templateUrl: 'flight-watch/components/slot-message-search-component.tpl.html',
      controller: function (FlightWatch, CommonMasterData, MessageService, EventManagerService) {
        var vm = this;

        vm.showSlotRightPanel = false;
        vm.isOpenPopOver = [];
        vm.slotMessageId = 0;
        vm.slotMessageSearchSummary = null;

        vm.modelSlotMessageSearch = {
          searchCriteria : {
            flightNumber : null,
            slotMessageTitle : null,
            flightUpdateStatus : null,
            fromDateStr : moment(new Date()).format("DD/MM/YYYY"),
            toDateStr : moment(new Date()).format("DD/MM/YYYY")
          },
          masterList : {
            slotMessageTypeList : ["SAM", "SRM", "SLC"],
            slotMessageStatusList : ["Completed", "Failed", "Flight Not Found", "Not Required", "Pending"]
          },
          dateRangeForTitle : "",
          fromDateAfterToDate : false
        };

        EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.SHOW_SLOT_SEARCH, clickOnSlotMessageRightPanelOpen);

        vm.clickOnSlotMessageRightPanelClose = function() {
          vm.showSlotRightPanel = false;

          // reset properties
          vm.slotMessageSearchSummary = null;
          vm.modelSlotMessageSearch.searchCriteria.flightNumber = null;
          vm.modelSlotMessageSearch.searchCriteria.slotMessageTitle = null;
          vm.modelSlotMessageSearch.searchCriteria.flightUpdateStatus = null;
          vm.modelSlotMessageSearch.searchCriteria.fromDateStr = moment(new Date()).format("DD/MM/YYYY");
          vm.modelSlotMessageSearch.searchCriteria.toDateStr = moment(new Date()).format("DD/MM/YYYY");
        };

        vm.changeField = function(flag) {
          if(flag == 'fromDateStr' && !!vm.modelSlotMessageSearch.searchCriteria.fromDateStr){
            if(!vm.modelSlotMessageSearch.searchCriteria.fullSchedule && !vm.modelSlotMessageSearch.searchCriteria.toDateStr){
              vm.modelSlotMessageSearch.searchCriteria.toDateStr = getMonthEndDate(vm.modelSlotMessageSearch.searchCriteria.fromDateStr);
            }
          }
          setDateValidationFlags();
          setDateRangeTitle();
        };

        vm.isObjectEmpty = function(){
          var result = false;
          if(vm.slotMessageSearchSummary != null){
            result = Object.keys(vm.slotMessageSearchSummary).length === 0;
          }
          return result;
        };

        vm.makeLowerCase = function(string){
          return string
            .split('_').join(' ')
            .toLowerCase()
            .replace(/(^| )(\w)/g, function(x) {
              return x.toUpperCase();
            });
        };

        vm.openSlotMessage= function(rowData){
          //close existing popover
          vm.isOpenPopOver[vm.slotMessageId] = false;

          // open new
          vm.popoverModel = rowData;
          vm.slotMessageId = rowData.slotMessageId;
          vm.isOpenPopOver[vm.slotMessageId] = true;
        };

        vm.closeBasePopover = function () {
          vm.isOpenPopOver[vm.slotMessageId] = false;
        };

        vm.closeDateRangePopover = function () {
          vm.isOpenPopOver[vm.slotMessageId] = false;
        };

        vm.searchSlotMessageSummaryClick = function() {
          setDateRangeTitle();
          vm.slotMessageSearchForm.$submitted = true;
          setDateValidationFlags();
          if (isSearchParamValid()) {
            var request = getSearchSlotMessageSummaryRequest(vm.modelSlotMessageSearch.searchCriteria);
            FlightWatch.searchSlotMessageSummary(request, function(response) {
              vm.slotMessageSearchSummary = _.groupBy(response, 'flightNumber');
            }, function(error) {
              MessageService.error(error);
            });
          }
        };

        function clickOnSlotMessageRightPanelOpen() {
          vm.showSlotRightPanel = true;
          vm.searchSlotMessageSummaryClick();
        }

        function getMonthEndDate(date) {
          if (!!date) {
            return moment(date, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
          }
          return null;
        }

        function setDateValidationFlags() {
          if (!isDateFormatInvalid(vm.modelSlotMessageSearch.searchCriteria.fromDateStr)
            && !isDateFormatInvalid(vm.modelSlotMessageSearch.searchCriteria.toDateStr)) {
            vm.modelSlotMessageSearch.fromDateAfterToDate = isDay1BeforeDay2(
              vm.modelSlotMessageSearch.searchCriteria.toDateStr,
              vm.modelSlotMessageSearch.searchCriteria.fromDateStr);
          } else {
            vm.modelSlotMessageSearch.fromDateAfterToDate = false;
          }
        }

        function setDateRangeTitle() {
          if (!!vm.modelSlotMessageSearch.searchCriteria.fromDateStr && !isDateFormatInvalid(vm.modelSlotMessageSearch.searchCriteria.fromDateStr)
            && !!vm.modelSlotMessageSearch.searchCriteria.toDateStr && !isDateFormatInvalid(vm.modelSlotMessageSearch.searchCriteria.toDateStr)) {
            var fromDateStr = moment(vm.modelSlotMessageSearch.searchCriteria.fromDateStr,
              'DD/MM/YYYY').format("Do MMM YYYY");
            var toDateStr = moment(vm.modelSlotMessageSearch.searchCriteria.toDateStr,
              'DD/MM/YYYY').format("Do MMM YYYY");
            vm.modelSlotMessageSearch.dateRangeForTitle = " - " + fromDateStr + " to "
              + toDateStr;
          } else {
            vm.modelSlotMessageSearch.dateRangeForTitle = "";
          }
        }

        // validate Date
        function isDateFormatInvalid(date) {
          if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
            return true;
          }
          return false;
        }

        // check from date and to date
        function isDay1BeforeDay2(day1, day2) {
          return moment(day1, "DD/MM/YYYY").isBefore(
            moment(day2, "DD/MM/YYYY"));
        }

        function getSearchSlotMessageSummaryRequest(searchCriteria) {
          var req = {};
          req.flightNumber = searchCriteria.flightNumber;
          req.slotMessageTitle = searchCriteria.slotMessageTitle;
          req.fromDateStr = searchCriteria.fromDateStr;
          req.toDateStr = searchCriteria.toDateStr;

          if(searchCriteria.flightUpdateStatus != null){
            req.flightUpdateStatus = searchCriteria.flightUpdateStatus.replace(/\s+/g, '_').toUpperCase();
          }

          return req;
        }

        function isSearchParamValid() {
          if (vm.slotMessageSearchForm.$valid && !vm.modelSlotMessageSearch.fromDateAfterToDate) {
            return true;
          }
          return false;
        }

      },
      bindings: {
        slotMessageSearchSummary : '='
      }
    });

})();
